import axios from "axios";

// Per-tab household selection (sessionStorage) so an advisor opening a client vault in a new tab
// never re-scopes their dashboard tab or another family's vault.
const KEY = "hv_household";
const HOME = "hv_home_household"; // self-serve families: remembered across tabs/devices-of-this-browser

export const getHousehold = () => sessionStorage.getItem(KEY) || "";
export const getHomeHousehold = () => localStorage.getItem(HOME) || "";
export const setHomeHousehold = (slug) => { if (slug) localStorage.setItem(HOME, slug); else localStorage.removeItem(HOME); };

const apply = (slug) => {
  if (slug) axios.defaults.headers.common["X-Household"] = slug;
  else delete axios.defaults.headers.common["X-Household"];
};

export const setHousehold = (slug) => {
  if (slug) sessionStorage.setItem(KEY, slug);
  else sessionStorage.removeItem(KEY);
  apply(slug);
};

export const householdQuery = () => (getHousehold() ? `h=${encodeURIComponent(getHousehold())}` : "");

// A tab with no explicit selection opens the family's own vault (set at sign-up), never an advisor client vault.
if (!getHousehold() && getHomeHousehold()) sessionStorage.setItem(KEY, getHomeHousehold());
apply(getHousehold());
localStorage.removeItem(KEY);

// A stale slug (archived vault) must never wedge the app: drop it and return to the primary vault.
axios.interceptors.response.use(undefined, (error) => {
  if (error?.response?.status === 404 && error.response.data?.code === "household_gone" && getHousehold()) {
    setHousehold("");
    window.location.replace("/vault?household=gone");
  }
  return Promise.reject(error);
});
